(() => {
  const DEFAULT_DEEP_LINK = "home";
  const READY_TIMEOUT = 8000;

  const deepLinkFromHash = (hash) => {
    if (!hash || !hash.startsWith("#smile-")) return "";
    return hash.slice("#smile-".length).replace(/-/g, "_") || DEFAULT_DEEP_LINK;
  };

  const deepLinkFromAnchor = (anchor) => {
    const attr = anchor.getAttribute("data-smile-deep-link");
    if (attr) return attr;

    try {
      const url = new URL(anchor.href, window.location.origin);
      const queryLink = url.searchParams.get("smile_deep_link");
      if (queryLink) return queryLink;
      const fromHash = deepLinkFromHash(url.hash || "");
      if (fromHash) return fromHash;
    } catch (error) {
      /* ignore malformed href */
    }

    return DEFAULT_DEEP_LINK;
  };

  const deepLinkFromLocation = () => {
    const queryLink = new URLSearchParams(window.location.search).get("smile_deep_link");
    if (queryLink) return queryLink;
    return deepLinkFromHash(window.location.hash || "");
  };

  const isSmileDeepLink = (anchor) => {
    if (!(anchor instanceof HTMLAnchorElement)) return false;
    if (anchor.hasAttribute("data-smile-deep-link")) return true;
    const href = anchor.getAttribute("href") || "";
    return /smile_deep_link=|#smile-/i.test(href);
  };

  const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

  // SmileUI 对象比 initialize 更早出现；没等 ready() 就 openPanel 会空转，并且不能当成已经打开。
  const openSmilePanel = (deepLink) => {
    const link = deepLink || DEFAULT_DEEP_LINK;
    const deadline = Date.now() + READY_TIMEOUT;

    const run = async () => {
      while (Date.now() < deadline) {
        const ui = window.SmileUI;
        if (ui && typeof ui.openPanel === "function") {
          try {
            if (typeof ui.ready === "function") await ui.ready();
            await ui.openPanel({ deep_link: link });
            return;
          } catch (error) {
            /* 初始化未完成，下一轮再开 */
          }
        }
        await wait(200);
      }
    };

    run();
  };

  document.addEventListener("click", (event) => {
    const anchor = event.target.closest("a");
    if (!isSmileDeepLink(anchor)) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openSmilePanel(deepLinkFromAnchor(anchor));
  });

  const initialLink = deepLinkFromLocation();
  if (initialLink) openSmilePanel(initialLink);
})();
